import { z } from "zod";
export const AdEraSchema = z.enum(["1950s", "1960s", "1970s", "1980s"]);
const productUrlSchema = z.string().trim().url().max(2048).refine((value) => {
    const url = new URL(value);
    return url.protocol === "https:" && !url.username && !url.password;
}, "Use an HTTPS product URL without credentials");
export const CreateAdCampaignSchema = z.object({
    name: z.string().trim().min(1).max(160).optional(),
    input_text: z.string().trim().min(20, "Describe the product in at least 20 characters, or provide its HTTPS URL").max(12000).optional(),
    product_url: productUrlSchema.optional(),
    status: z.enum(["ACTIVE", "PAUSED"]).default("ACTIVE"),
    station_ids: z.array(z.string().uuid()).max(68).default([]),
    eras: z.array(AdEraSchema).min(1).max(4).default(["1950s", "1960s", "1970s", "1980s"]),
    max_per_hour: z.number().int().min(0).max(240).default(2),
    max_per_day: z.number().int().min(0).max(5760).default(12),
    min_gap_minutes: z.number().int().min(0).max(1440).default(30)
}).strict().refine((value) => Boolean(value.input_text || value.product_url), {
    message: "Provide a product description or product URL",
    path: ["input_text"]
});
export const AdCampaignStatusSchema = z.object({
    status: z.enum(["ACTIVE", "PAUSED"])
}).strict();
export const AdCampaignLimitsSchema = z.object({
    max_per_hour: z.number().int().min(0).max(240),
    max_per_day: z.number().int().min(0).max(5760),
    min_gap_minutes: z.number().int().min(0).max(1440)
}).strict();
export const StationAdPolicySchema = z.object({
    enabled: z.boolean().default(false),
    max_per_hour: z.number().int().min(0).max(240).default(4),
    max_per_day: z.number().int().min(0).max(5760).default(48),
    min_gap_minutes: z.number().int().min(0).max(1440).default(10),
    program_overrides: z.record(z.string().uuid(), z.boolean()).default({})
}).strict();
